"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lens = exports.Prism = exports.Optic = void 0;
const simple_cache_1 = require("./simple-cache");
function createModify(getter, setter) {
    return function modify(updateFn, s) {
        // tslint:disable-line
        return setter(updateFn(getter(s)), s);
    };
}
var Optic;
(function (Optic) {
    function optic(getter, setter) {
        return {
            get: getter,
            set: setter,
            modify: createModify(getter, setter),
        };
    }
    Optic.optic = optic;
})(Optic = exports.Optic || (exports.Optic = {}));
var Prism;
(function (Prism) {
    function create(getter, setter) {
        return {
            get: getter,
            set: setter,
            modify: createModify(getter, setter),
            compose(next) {
                // no runtime dispatch – the implementation works for both
                // lens and prism argument
                return create((s) => {
                    const x = getter(s);
                    return x !== undefined ? next.get(x) : undefined;
                }, (v, s) => {
                    const x = getter(s);
                    return x !== undefined ? setter(next.set(v, x), s) : s;
                });
            },
        };
    }
    Prism.create = create;
})(Prism = exports.Prism || (exports.Prism = {}));
var Lens;
(function (Lens) {
    /**
     * Create a lens.
     *
     * @export
     * @template O type of the source
     * @template P type of the destination
     * @param getter a getter function
     * @param setter a setter function
     * @returns a lens that operates by given getter and setter
     */
    function create(getter, setter) {
        const cache = new simple_cache_1.SimpleCache(next => create((s) => next.get(getter(s)), (v, s) => setter(next.set(v, getter(s)), s)));
        return {
            get: getter,
            set: setter,
            modify: createModify(getter, setter),
            compose(next) {
                return cache.getOrCreate(next);
            },
        };
    }
    Lens.create = create;
    function compose(...lenses) {
        if (lenses.length === 0) {
            throw new TypeError("Can not compose zero lenses. You probably want `Lens.identity`.");
        }
        else if (lenses.length === 1) {
            return lenses[0];
        }
        else {
            return lenses.slice(1).reduce((c, l) => c.compose(l), lenses[0]);
        }
    }
    Lens.compose = compose;
    const _identity = create(x => x, (x, _) => x);
    /**
     * The identity lens – a lens that reads and writes the object itself.
     */
    function identity() {
        return _identity;
    }
    Lens.identity = identity;
    const _nothing = Prism.create(_ => undefined, (_, o) => o);
    /**
     * A lens that always returns `undefined` on `get` and does no change on `set`.
     */
    function nothing() {
        return _nothing;
    }
    Lens.nothing = nothing;
})(Lens = exports.Lens || (exports.Lens = {}));
